import { Component, OnDestroy, OnInit,Renderer2 } from '@angular/core';
import { Subject, forkJoin,Subscription, interval, of } from 'rxjs';
import { AlertService } from 'src/app/services/alert.service';
import { DischargeService } from 'src/app/services/discharge.service';
import { TankService } from 'src/app/services/tank.service';
import { UserService } from 'src/app/services/user.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { VoucherService } from 'src/app/services/voucher.service';
import { Discharge } from 'src/app/shared/models/Discharge';
import { Tank } from 'src/app/shared/models/Tank';
import { User } from 'src/app/shared/models/User';
import { Vehicle } from 'src/app/shared/models/Vehicle';
import { Voucher, VoucherStatus } from 'src/app/shared/models/Voucher';
import { PrinterService } from 'src/app/services/printer.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DispenserService } from 'src/app/services/dispenser.service';
import { DatePipe } from '@angular/common';
import { catchError, switchMap, takeUntil } from 'rxjs/operators';
import { Fuel } from 'src/app/shared/models/Fuel';
import { Router } from '@angular/router';
import { InternetMonitorService } from 'src/app/services/internet-monitor.service';
import { ToastrService } from 'ngx-toastr';
import { FuelService } from 'src/app/services/fuel.service';
import { DischargeForPrint } from 'src/app/shared/models/DischargeForPrint';
import swal from 'sweetalert';



@Component({
  selector: 'app-discharge-page',
  templateUrl: './discharge-page.component.html',
  styleUrls: ['./discharge-page.component.css']
})
export class DischargePageComponent implements OnInit, OnDestroy {
  dischargeForm: FormGroup;
  currentTank: Tank;
  initialTankAvailable;
  vehicleList: Vehicle[];
  vehicleListOptions: Vehicle[];
  voucherList: Voucher[];
  selectedVoucher: Voucher;
  newDischarge = new Discharge;
  voucher = new Voucher;
  initialVoucherAvailable;
  dischargeInProgress = false;
  typeOfUse = null;
  date;
  online = false;
  currentDateTime: string;
  useOfVehicle: number = null;
  isSaving = false;
  currentVehicle: Vehicle;
  currentUser: User;
  currentFuel: Fuel;
  vehiclesPage = { index: 0, size: 15, last: false };
  initialTankAmountFilter: number;
  flow = 0;
  intervalId: any;
  printerEnabled: boolean;
  isPrintButtonVisible = true;
  historicalTankAmountDiffToAdd;
  selectedOption: string;
  private unsubscribe$ = new Subject<void>();
  isModalOpen = false;
  disableFinishButton = false;
  noVouchersAvailable = false;
  filteredVoucherList: Voucher[];
  private intervalSubscription: Subscription;

  showLitrosInput = false;
  showPrecioInput = false;
  litrosValue: number = null;
  precioValue: number = null;
  convertedLitros: string = '';
  convertedPrice: string = '';
  isLowFuel: boolean = false;


  constructor(
    private fb: FormBuilder,
    private voucherService: VoucherService,
    private dischargeService: DischargeService,
    private tankService: TankService,
    private fuelService: FuelService,
    private userService: UserService,
    private alertService: AlertService,
    private printerService: PrinterService,
    private vehicleService: VehicleService,
    private dispenserService: DispenserService,
    private datePipe: DatePipe,
    private renderer: Renderer2,
    private router: Router,
    private toastrService: ToastrService,
    private internetMonitorService: InternetMonitorService,
  ) { }

  ngOnInit() {
    this.internetMonitorService.internetConnection$.subscribe(isConnected => {
      this.online = isConnected; // Actualizamos la variable 'online' según el estado de conexión.
      
    });

    this.renderer.setStyle(document.body, 'overflow-y', 'hidden');
    this.updateDateTime();
    this.newDischarge.amount = 0;
    this.newDischarge.status = 0;
    this.initializeFormAndSubscription();
    this.currentUser = this.userService.currentUser;

    this.tankService.getCurrentTank().subscribe(
      (tank: Tank) => {
        if (!tank.name) {
          window.location.reload();
        }
      });


    this.tankService.getCurrentTank()
      .pipe(
        takeUntil(this.unsubscribe$),
        switchMap((tank: Tank) => {
          if (!tank) {
            swal({
              title: "No se encontro tanque para este operador",
              text: "",
              icon: "error",
              dangerMode: true,
            })
              .then(willDelete => {
                if (willDelete) {

                  this.logout();
                }
              });
          } else { // El tanque es válido, continúa con el flujo normal
            
            this.handleTankData(tank);
            this.currentTank = tank;
            this.fuelService.getFuelByTank(tank.id).subscribe((fuel: Fuel[]) => {
              this.currentFuel = fuel[0];
            });

            if (this.currentTank.available < 1) {
              //window.confirm('NO cuenta con stock para descargas');
              swal("NO cuenta con stock para realizar descargas", '', "error")

            }

            if (tank.available < tank.availableAlert) {
              this.isLowFuel = true;
            } else {
              this.isLowFuel = false;
            }

            return this.fetchVouchersAndVehicles(tank.id);
          }

        }),
        catchError((error) => {
          console.error('Error al obtener el tanque actual:', error);

          swal({
            title: "ERROR",
            text: "Voucher o Vehiculo no encontrado: No se encontro Voucher o Vehiculo para este Tanque",
            icon: "error",
            dangerMode: true,
          })
            .then(willDelete => {
              if (willDelete) {

                this.logout();
              }
            });

          return of([[], []]); // Proporcionar valores por defecto para vouchers y vehicles
        })
      )
      .subscribe((result: [Voucher[], Vehicle[]]) => {
        const [vouchers, vehicles] = result;
        console.log(vouchers)
        this.voucherList = vouchers.filter(voucher =>
          voucher.status === 'ACTIVE' &&
          ((
            (voucher.operator === this.currentUser.id )
            || 
            (voucher.operators && voucher.operators.includes(this.currentUser.id)
          )
          || 
          (
            voucher.operators.length == 1 && voucher.operators[0] == 0
          )
          ))
        );
        // console.log('VOUCHERRRafert',this.voucherList)

        this.vehicleList = vehicles;
        this.vehicleListOptions = this.vehicleList;

        if (this.currentTank.byVehicle) {
          this.initializeFormAndSubscription();
        } else {
          this.initializeFormAndSubscription();
          if (this.voucherList.length === 1) {
            this.dischargeForm.get('voucherId').setValue(this.voucherList[0]._id);
          }
        }
      });
    this.setupDateTimeUpdater();
  }

  private handleTankData(tank: Tank) {
    this.currentTank = tank;
    this.currentTank.id = tank.id;
    if (tank.printerEnabled) {
      this.printerEnabled = tank.printerEnabled;
      //cambiar
      this.checkPaper();
    }
  }

  private fetchVouchersAndVehicles(tankId: Number) {
    return forkJoin([
      this.voucherService.getVoucherByTank(tankId),
      this.vehicleService.getVehicleByTank(tankId)
    ]);
  }

  private initializeFormAndSubscription() {
    this.dischargeForm = this.initDischargeForm();

    this.dischargeForm.get("voucherId").valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(f => {
        this.onVoucherChanged(f);
      });

  }

  private setupDateTimeUpdater() {
    this.intervalSubscription = interval(1000).subscribe(() => {
      this.updateDateTime();
    });
  }


  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }

  }

  checkPaper() {
    // Si tiene configurada la impresora, chequear papel
    // console.log(`this printer enabled: ${this.printerEnabled}`);
    this.printerService.hasPaper()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(response => {
        // console.log('respuesta de check paper:');
        // console.log(response);
        if (!response.hasPaper) {
          //this.alertService.add({body: 'Impresora SIN PAPEL: Su ticket no será impreso',type: AlertType.DANGER});
          //this.toastrService.info('Impresora SIN PAPEL: Su ticket no será impreso', 'Info');
          swal("Impresora SIN PAPEL: Su ticket no será impreso", '', "error")
        }
      });
  }

  onVoucherChanged(value) {

    this.selectedVoucher = this.voucherList.find((voucher) => voucher._id === value);
    // console.log(value)
    this.voucher = this.selectedVoucher;
    // console.log(this.voucher)


    if (!this.currentTank.byVehicle){
      this.currentVehicle = null;
      if (this.voucher.vehicles && this.voucher.vehicles.length == 1 && this.voucher.vehicles[0] == 0 ){
        this.vehicleListOptions = this.vehicleList;
      }
      else if (this.voucher.vehicles && this.voucher.vehicles.length>0){
        if (this.voucher.vehicles.length>1)
          this.vehicleListOptions = this.vehicleList.filter( e => this.voucher.vehicles.includes(e.id));
        else {
          this.vehicleListOptions = this.vehicleList.filter( e => this.voucher.vehicles.includes(e.id));
          this.currentVehicle = this.vehicleList.find((vehicle) => vehicle._id === this.vehicleListOptions[0]._id);
        }
      }
      else{
        this.vehicleListOptions = this.vehicleList.filter( e => e.id == this.voucher.vehicle);
        this.currentVehicle = this.vehicleList.find((vehicle) => vehicle._id === this.vehicleListOptions[0]._id);

      }
    }

    if (this.voucher){
      if ((this.voucher.km_is_active == undefined) || (this.voucher.km_is_active == true)) {
        this.dischargeForm.get('useOfVehicle').setValidators(Validators.required);
      }else{
        this.dischargeForm.get('useOfVehicle').clearValidators();
      }
  
      this.dischargeForm.get('useOfVehicle').updateValueAndValidity();
    }

  }

  onVehicleChanged(value) {
    this.currentVehicle = this.vehicleList.find((vehicle) => vehicle._id === value);
    if (this.currentVehicle && this.currentTank.byVehicle ) {
   
      const relatedVouchers = this.voucherList.filter((voucher) => {
        if ( voucher.vehicles.includes(this.currentVehicle.id) ){//check voucher for vehicles
          return true;
       }else if (voucher.vehicles.length==1 && voucher.vehicles[0] == 0){//check voucher for ALL vehicles
        return true;

       }else if (voucher.vehicle == value)//check for old code of SD
       {
        return true;
       }
       return false
      }
       
      );

      // Actualizamos la lista de vouchers que se muestran en el select
      this.filteredVoucherList = relatedVouchers;

      // Asigna el primer voucher si existe
      if (relatedVouchers.length > 0) {
        this.selectedVoucher = relatedVouchers[0];
        this.voucher = this.selectedVoucher;
        this.dischargeForm.get('voucherId').setValue(this.selectedVoucher._id);
        this.noVouchersAvailable = false;
      } else {
        // Si no hay vouchers relacionados, se marca como no disponible
        this.selectedVoucher = null;
        this.voucher = null;
        this.dischargeForm.get('voucherId').setValue(null);
        this.noVouchersAvailable = true;
      }
    }

    // console.log(this.filteredVoucherList,'lll')
    this.isModalOpen = false;
  }


  initDischargeForm(): FormGroup {

      return this.fb.group({
        voucherId: ['', Validators.required],
        // vehicleId: ['', Validators.required],
        currentTank: [''],
        useOfVehicle: ['',Validators.required],
        selectedOption: ['kms',Validators.required],
        litros: [null],
        precio: [null]
      });


  }

  start() {
    
    // console.log(this.dischargeForm.value)
    this.initializeDischarge();
    this.setInitialValues();

    const minAmount = Math.min(this.voucher.available as number, this.currentTank.available as number);
    const timeout = this.currentTank.automaticPumpCuttingEnabled ? this.currentTank.automaticPumpCuttingTime : null;
    this.initSaving();
    //cambiar
    this.dispenserService.startDischarge(minAmount, timeout, this.currentTank.encoderSpeed)
      //this.dispenserService.fakeStartDischarge(minAmount, timeout, this.currentTank.encoderSpeed)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (partialDischarge: any) => {
          this.updatePartialDischarge(partialDischarge);
        },
        (err) => {
          this.handleDischargeError(err);
        },
        () => {
          this.handleDischargeCompletion();
        }
      );
  }

  initializeDischarge() {
    this.newDischarge = new Discharge();
    this.newDischarge.status = 0;
    this.newDischarge.amount = 0;
    this.historicalTankAmountDiffToAdd = 0;
    this.isPrintButtonVisible = true;
    this.newDischarge.date = new Date();

    this.newDischarge.tankId = this.currentTank.id;
    this.newDischarge.fuelId = this.currentFuel.id;
    this.newDischarge.person = this.currentUser.id;
    this.newDischarge.person = this.currentUser.id;

    // console.log('initializeDischarge');
    // console.log('voucher:', this.voucher.id, 'Name: ', this.voucher.description);
    // console.log('tank: ', this.currentTank.id);
    // console.log('Fuel id:  ', this.currentFuel.id, 'Name: ', this.currentFuel.name)

    this.userService.getUser(this.currentUser.id).subscribe(
      (user_con_razon_social) => {
        // console.log('User:', this.currentUser.id, 'Razon social:', user_con_razon_social.cuitName);
        this.currentUser.lastname = user_con_razon_social.lastname;
        this.newDischarge.razon_social = user_con_razon_social.cuitName;
        // console.log('Nombre de usuario: ', this.currentUser.lastname);
        this.newDischarge.user_name = this.currentUser.lastname;
      },
      (error) => {
        // Manejo de errores
        console.log('Error:', error);
      }
    );
    this.newDischarge.voucherId = this.voucher.id;
    this.newDischarge.voucher_description = this.voucher.description;
    this.newDischarge.fuelId = this.currentFuel.id;
    this.newDischarge.fuel_name = this.currentFuel.name;
    this.newDischarge.vehicle = this.currentVehicle.id;
    this.newDischarge.vehicle_name = this.currentVehicle.name;
    this.newDischarge.kilometers = 0;
    this.newDischarge.hours = 0;



  }

  setInitialValues() {
    this.initialVoucherAvailable = this.voucher.available;
    this.initialTankAvailable = this.currentTank.available;
    this.initialTankAmountFilter = this.currentTank.amountFilter;
    this.dischargeInProgress = true;
  }

  updatePartialDischarge(partialDischarge: any) {
    let newAmount = partialDischarge.amount;

    this.flow = (newAmount - this.newDischarge.amount) / (0.1 / 60);
    this.historicalTankAmountDiffToAdd = newAmount - this.newDischarge.amount;

    const litrosValue = this.dischargeForm.get('litros').value;
    const precioValue = this.dischargeForm.get('precio').value;

    // Limitamos por litros
    if (litrosValue != null && litrosValue >= 0 && newAmount >= litrosValue) {
      newAmount = litrosValue;
    }

    // Limitamos por precio
    if (precioValue != null && this.currentFuel.cost) {
      const litrosEquivalentes = precioValue / this.currentFuel.cost;
      if (newAmount >= litrosEquivalentes) {
        newAmount = litrosEquivalentes;
      }
    }

    // Actualizamos la descarga con el valor limitado
    this.newDischarge.amount = newAmount;
    this.newDischarge.dischargeInProgress = true;


    this.currentTank.available = this.initialTankAvailable - this.newDischarge.amount;
    this.voucher.available = this.initialVoucherAvailable - this.newDischarge.amount;
    this.currentTank.historicalDischargesAmount += this.historicalTankAmountDiffToAdd;

    if (this.currentTank.filterLife) {
      this.currentTank.amountFilter = this.initialTankAmountFilter as number + this.newDischarge.amount;
    }

   
    this.checkDischargeLimit();
  }

  // updatePartialDischarge(partialDischarge: any) {
  //   this.flow = (partialDischarge.amount - this.newDischarge.amount) / (0.1 / 60);
  //   // console.log("partialDischarge.amount: ", partialDischarge.amount)
  //   // console.log("this.newDischarge.amount: ", this.newDischarge.amount)
  //   // console.log("this.flow: ", this.flow)

  //   this.historicalTankAmountDiffToAdd = partialDischarge.amount - this.newDischarge.amount;
  //   this.newDischarge.amount = partialDischarge.amount;
  //   this.newDischarge.dischargeInProgress = true;


  //   // this.newDischarge.tankId = this.currentTank.id;
  //   //this.newDischarge.fuelId = this.currentFuel.id;
  //   this.currentTank.available = this.initialTankAvailable - this.newDischarge.amount;
  //   this.voucher.available = this.initialVoucherAvailable - this.newDischarge.amount;
  //   this.currentTank.historicalDischargesAmount += this.historicalTankAmountDiffToAdd;

  //   if (this.currentTank.filterLife) {
  //     this.currentTank.amountFilter = this.initialTankAmountFilter as number + this.newDischarge.amount;
  //   }
  // }

  handleDischargeError(err: any) {
    this.dischargeInProgress = false;
    if (err.message === 'SECURITY_PULSES_COUNT_ABORTED') {
      this.isPrintButtonVisible = true;
    } else {
      //this.alertService.add({ body: 'Hubo problemas en la comunicación con el surtidor', type: AlertType.DANGER });
      this.printTicket();
      swal("Hubo problemas en la comunicación con el surtidor", '', "error")
      //this.toastrService.error('Hubo problemas en la comunicación con el surtidor', 'Error');
    }
    this.newDischarge.status = err.code;
    this.newDischarge.dischargeInProgress = this.dischargeInProgress;
    this.flow = 0;
    this.checkVoucherStatus(this.voucher);
    this.save(true);
  }

  handleDischargeCompletion() {

    this.newDischarge.status = 0;
    // this.newDischarge.amount = 0;
    this.flow = 0;
    this.newDischarge.dischargeInProgress = this.dischargeInProgress;
    this.checkVoucherStatus(this.voucher);
    this.save(true);
    this.toastrService.success('Descarga completada. Imprimiendo ticket...', 'Éxito');
    
    // Terminó la descarga
    this.dischargeInProgress = false;
    this.disableFinishButton = false;

  }

  initSaving() {
    this.intervalId = setInterval(() => {
      this.save();
    }, 1000);
  }


  async finish() {
    // Save tank amount
    this.disableFinishButton = true;

    await this.dispenserService.stopDischarge();

    //this.dispenserService.fakeStopDischarge();

    const num = this.initialTankAvailable - this.newDischarge.amount;
    this.newDischarge.tankAvailable = num.toFixed(1);
    //cambiar

    if (this.currentTank.printerEnabled) {
      this.isPrintButtonVisible = true;
    }
    this.handleDischargeCompletion();

  }


  save(finished?: boolean) {
    if (finished) {
      this.handleFinishedState();
      this.updateVoucher();
      this.updateTank();
      this.updateExistingDischarge();
      this.tankService.updateTankAvailable(this.currentTank.id);
    }

    this.isSaving = true;

    if (!this.newDischarge._id) {

      this.selectedOption = this.dischargeForm.value.selectedOption;
      this.useOfVehicle = this.dischargeForm.value.useOfVehicle;
      // console.log("************************selectedOption", this.selectedOption)
      // console.log("************************useOfVehicle", this.useOfVehicle)

      if (this.selectedOption === "kms") {
        this.newDischarge.kilometers = this.useOfVehicle;
      } else if (this.selectedOption === "horas") {
        this.newDischarge.hours = this.useOfVehicle;
      }

      this.createNewDischarge();
    } else {
      this.updateExistingDischarge();
    }



    if (finished) {
      //this.toastrService.success('Carga guardado con éxito', 'Éxito');
      //cambiar

      setTimeout(() => {
        // Este bloque de código se ejecutará después de 3000 milisegundos (3 segundos)
        this.printTicket();
        //console.log('Imprimiendo ticket después de guardar la descarga finalizada.');
      }, 3000);
    }
  }

  async handleFinishedState() {
    clearInterval(this.intervalId);

    if (this.currentTank.filterLife && this.currentTank.filterLife <= this.currentTank.amountFilter) {
      await swal("Debe cambiar el filtro del tanque", '', "error")
    }

    if ((this.currentTank.available as number) <= (this.currentTank.availableAlert as number)) {
      await swal("El nivel del tanque es menor a: " + this.currentTank.availableAlert, '', "error");
    }

  }

  createNewDischarge() {
    this.dischargeService.saveDischarge(this.newDischarge)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (dischargeRes) => {
          console.log('Guardo Descarga ',dischargeRes._id);
          this.newDischarge._id = dischargeRes._id;
          this.newDischarge.id = dischargeRes.id;
          this.updateVoucher();
          this.updateTank();
        },
        (err) => {
          this.handleSaveError(err, 'Hubo problemas al guardar la información de la descarga');
        }
      );
  }

  updateExistingDischarge() {
    this.dischargeService.editDischarge(this.newDischarge._id, this.newDischarge)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        () => {
          this.updateVoucher();
          this.updateTank();
        },
        (err) => {
          this.handleSaveError(err, 'Hubo problemas al guardar la información de la descarga');
        }
      );
  }

  updateVoucher() {
    // console.log('voucher a actualizar: ', this.voucher.id);
    this.voucher.sync_date = null;
    this.voucherService.editVoucher(this.voucher.id, this.voucher)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        () => {
          this.isSaving = false;
        },
        (err) => {
          this.handleSaveError(err, 'Hubo problemas al guardar la información del voucher');
        }
      );
  }

  updateTank() {
    this.tankService.editTank(this.currentTank.id, this.currentTank)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        () => {
          this.isSaving = false;
        },
        (err) => {
          this.handleSaveError(err, 'Hubo problemas al guardar la información del tanque');
        }
      );
  }

  handleSaveError(err: any, errorMessage: string) {
    console.error(err);
    //this.alertService.add({ body: errorMessage, type: AlertType.WARNING });
    //this.toastrService.error(errorMessage, 'Error');
    swal("Oops" + errorMessage, '', "error")
    this.isSaving = false;
  }

  checkVoucherStatus(voucher: Voucher) {
    if (voucher.available < 1 || voucher.single_use) {
      voucher.status = VoucherStatus.FINISHED;
    }
  }

  updateDateTime() {
    const currentDate = new Date();
    this.currentDateTime = this.datePipe.transform(currentDate, 'dd/MM/yy HH:mm:ss');
  }

  getDischargeAmount(): string {
    if (!isNaN(this.newDischarge.amount) && typeof this.newDischarge.amount === 'number') {
      return this.newDischarge.amount.toFixed(2);
    } else {
      return '0.00';
    }
  }

  checkDischargeLimit() {
    const litrosValue = this.dischargeForm.get('litros').value;
    const precioValue = this.dischargeForm.get('precio').value;
    const amount = this.newDischarge.amount;

    // Caso litros
    if (litrosValue != null && litrosValue >= 0) {
      if (amount >= litrosValue) {        //para cortar exacto
        this.finish();
        this.disableFinishButton = false;
        return;
      }
    }

    // Caso precio
    if (precioValue != null && precioValue >= 0 && this.currentFuel.cost) {
      const litrosEquivalentes = precioValue / this.currentFuel.cost;
      if (amount >= litrosEquivalentes) {
        this.finish();
        this.disableFinishButton = false;
        return;
      }
    }
  }

  // getDischargeAmount(): string {
  //   if (!isNaN(this.newDischarge.amount) && typeof this.newDischarge.amount === 'number') {
  //     const litrosValue = this.dischargeForm.get('litros').value;
  //     if (this.currentTank.aprox_by_litros && litrosValue != null){//STOP BY PRICE
  //       const cost = this.currentFuel.cost;
  //       const aprox_litros_to_load = litrosValue / cost;
  //       if (aprox_litros_to_load != null && aprox_litros_to_load - this.newDischarge.amount<0){
  //         this.finish();
  //         this.disableFinishButton = false;
  
  //       }
  //     }else{
  //       if (litrosValue != null && litrosValue - this.newDischarge.amount<0){
  //         this.finish();
  //         this.disableFinishButton = false;
  
  //       }//90824
  //     }
      
  //     return this.newDischarge.amount.toFixed(2);
  //   } else {
  //     return '0.00';
  //   }

  // }

  // Funcion para calcular litros o pesos aproximados en los botones
  toggleInput(type: 'litros' | 'precio') {
    if (type === 'litros') {
      this.showLitrosInput = !this.showLitrosInput;
      this.showPrecioInput = false;
    } else if (type === 'precio') {
      this.showPrecioInput = !this.showPrecioInput;
      this.showLitrosInput = false;
    }
  }

  onInputChange(inputType: string, value: number) {
    if (!this.currentFuel || !this.currentFuel.cost) {
      this.convertedLitros = '';
      this.convertedPrice = '';
      return;
    }

    if (!value) {
      this.convertedLitros = '';
      this.convertedPrice = '';
      this.showLitrosInput = false;
      this.showPrecioInput = false;
      return; // Salimos de la función
    }

    if (inputType === 'litros') {
      this.convertedLitros = value.toFixed(2);
      this.showLitrosInput = true;
    } else if (inputType === 'precio') {
      this.convertedPrice = value.toFixed(2);
      this.showPrecioInput = true;
    }
  }

  printTicket() {
    if (this.currentTank.printerEnabled) {
      const currentDateStr = this.datePipe.transform(Date.now(), 'dd/MM/yyyy HH:mm:ss', '-03');
      //const newDischargeForPrint: Discharge = { ...this.newDischarge, date: new Date(currentDateStr) };
      const newDischargeForPrint = new DischargeForPrint();
      newDischargeForPrint._id = this.newDischarge._id;
      newDischargeForPrint.id = this.newDischarge.id;
      newDischargeForPrint.driver = this.currentVehicle.driver;
      newDischargeForPrint.voucherId = this.newDischarge.voucherId;
      // newDischargeForPrint.sequence = this.newDischarge.id.toString();
      newDischargeForPrint.date = currentDateStr;
      newDischargeForPrint.user = this.currentUser.name + " " + this.currentUser.lastname
      newDischargeForPrint.vehicle = this.currentVehicle.name;
      newDischargeForPrint.tank = this.currentTank.name;
      newDischargeForPrint.kilometers = this.newDischarge.kilometers !== undefined ?
        this.newDischarge.kilometers.toString() : '';
      newDischargeForPrint.hoursOfUse = this.newDischarge.hours !== undefined ?
        this.newDischarge.hours.toString() : '';
      newDischargeForPrint.fuel = this.currentFuel.name;
      newDischargeForPrint.amount = this.newDischarge.amount.toFixed(2).toString();

      this.printerService.printTicket(newDischargeForPrint)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(response => {
          console.log('Ha vuelto del print service');
          // mensaje 200: OK Mensaje 500: error
          if (response.code === 200) {
            console.log('Ticket impreso');
          }
          if (response.code === 500) {
            console.log(response.message);
            //this.alertService.add({ body: `Impresora Error: ${response.message}`, type: AlertType.DANGER });
            //this.toastrService.error('Impresora Error: ${response.message}', 'Error');
            swal("mpresora Error:", response.message, "error")
          }
        });
    }
  }

  logout() {
//     let litrosValue = this.dischargeForm.get('litros').value;
// console.log('Valor de litros:', litrosValue);

    this.userService.logout();
    this.router.navigate(['login']);
  }

  openModal() {
    this.isModalOpen = true; // Abre el modal
  }

  closeModal() {
    this.isModalOpen = false; // Cierra el modal
  }

  updateVehicleId(selectedVehicleId) {
    //console.log('updateVehicleId - Vehículo seleccionado desde el modal:', selectedVehicleId);

    this.currentVehicle = this.vehicleList.find(vehicle => vehicle._id === selectedVehicleId);

    if (this.currentVehicle) {
      this.onVehicleChanged(selectedVehicleId);
    }
  }

  openLitrosInput() {
    const wasVisible = this.showLitrosInput;

    this.showLitrosInput = !wasVisible;
    this.showPrecioInput = false;

    if (!wasVisible) {
      this.litrosValue = null;
      this.currentTank.aprox_by_litros = true;
    }
  }

  openPrecioInput() {
    const wasVisible = this.showPrecioInput;

    this.showPrecioInput = !wasVisible;
    this.showLitrosInput = false;

    if (!wasVisible) {
      this.precioValue = null;
      this.currentTank.aprox_by_litros = false;
    }
  }

  get fontSizeClass(): string {
    return this.newDischarge.amount >= 100 ? 'displayInline smallfixFont align-bottom' : 'displayInline fixFont align-bottom';
  }

  toggleSelectedOption() {
    const current = this.dischargeForm.value.selectedOption;
    const newOption = current === 'kms' ? 'horas' : 'kms';
    this.dischargeForm.patchValue({ selectedOption: newOption });
  }
  
  

 

 

}
